import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/**
 * iOS はフォントサイズ 16px 未満の入力にフォーカスするとページを自動拡大する。
 * 自分の入力欄は 16px にしてあるが、埋め込みチャット (cross-origin iframe) の
 * 入力欄は CSS を触れないため、iOS に限って maximum-scale を立てて拡大を抑える。
 * iOS 10 以降の Safari はピンチ操作自体はこの指定を無視して許可するので、
 * 拡大手段そのものは失われない。他のプラットフォームでは指定しない
 * (そちらでは maximum-scale がピンチ拡大まで禁止してしまうため)。
 */
if (/iPad|iPhone|iPod/.test(navigator.userAgent) || (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1)) {
  const meta = document.querySelector('meta[name="viewport"]');
  meta?.setAttribute(
    'content',
    // viewport-fit は付けない (既定の auto = セーフエリア内に自動で収める)。
    // index.html 側のコメントを参照。
    'width=device-width, initial-scale=1, maximum-scale=1',
  );
}

// Service Worker は本番 (https) でのみ登録する。
if ('serviceWorker' in navigator && window.location.protocol === 'https:') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* 登録できなくてもアプリは動作する */
    });
  });
}
